import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import Img from "../../images/services/et/Rev-Coin-02.png";
import {LazyLoadImage} from "react-lazy-load-image-component";
import {Link} from 'gatsby';

function Revcoin(props) {
    return (
        <div className="services_solution tekrevol_gray_bg  p-100">
            <Container>
                <Row>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
                            <h2>Empowering Employees with Rev Coin</h2>
                            <p>Rev Coin is a state-of-the-art crypto stock-based solution created by TekRevol, utilizing blockchain technology to revolutionize employee benefits. It empowers employees by providing a tangible stake in the company, fostering a sense of ownership, loyalty, and potential side income through transparent and controlled transactions.</p>
                            <Link to="/contact"
                                  className="border_btn" aria-label="TekRevol Contact">Explore more</Link>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
                        <div className="rev-img">
                            <LazyLoadImage
                                src={Img}
                                effect="blur" alt="Image" className="img-fluid"
                            />
                        </div>

                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Revcoin;